import React, { useState } from 'react';
import { RtModal, RtModalField } from '../../ui/RtModal';

const DuplicateModal = ({ isOpen, onClose, project, onDuplicate }) => {
  const [newProjectName, setNewProjectName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen || !project) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    setIsLoading(true);
    setError(null);

    try {
      await onDuplicate(newProjectName || project.name);
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to duplicate project');
    } finally {
      setIsLoading(false);
    }
  };

  const close = () => {
    if (!isLoading) onClose();
  };

  return (
    <RtModal
      open={isOpen}
      onClose={close}
      title="Duplicate Project"
      subtitle="Create a copy of your existing project"
      size="sm"
      closeDisabled={isLoading}
      closeOnBackdrop={!isLoading}
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={close}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="rt-duplicate-project-form"
            className="rt-btn rt-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Duplicating…' : 'Duplicate'}
          </button>
        </>
      }
    >
      <form id="rt-duplicate-project-form" onSubmit={handleSubmit}>
        <div className="rt-modal-confirm" style={{ marginBottom: 16 }}>
          <p className="rt-modal-confirm__message">
            <span>{project.name}</span>
            <span aria-hidden> → </span>
            <span>{newProjectName || 'New Project'}</span>
          </p>
        </div>

        <RtModalField
          label="New Project Name"
          htmlFor="duplicate-project-name"
          required
          error={error || null}
        >
          <input
            id="duplicate-project-name"
            type="text"
            placeholder={`e.g. ${project.name}-copy`}
            defaultValue={project.name}
            onChange={(e) => setNewProjectName(e.target.value)}
            autoFocus
            required
            disabled={isLoading}
          />
        </RtModalField>
      </form>
    </RtModal>
  );
};

export default DuplicateModal;
